import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const activateLicense = createAsyncThunk('licenseSlice/activateLicense', async (values) => {
  try {
    const response = await axios.post(`/License/activatelicense`, values);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const deActivateLicense = createAsyncThunk('licenseSlice/deActivateLicense', async (values) => {
  try {
    const response = await axios.post(`/License/deactivatelicense`, values);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const getLicenseDetails = createAsyncThunk('licenseSlice/getLicenseDetails', async () => {
  const response = await axios.get(`/License/getlicense`);
  return response.data;
});

export const checkLicense = createAsyncThunk('licenseSlice/checkLicense', async () => {
  try {
    const response = await axios.post(`/License/checklicense`);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

const initialState = {
  licenseDetails: null,
  trialExpired: null,
};

const licenseSlice = createSlice({
  name: 'licenseSlice',
  initialState,
  reducers: {
    setLicenseStatus: (state, action) => {
      state.licenseDetails = action.payload;
    },
    setTrialExpired: (state, action) => {
      state.trialExpired = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLicenseDetails.fulfilled, (state, action) => {
      state.licenseDetails = action.payload;
    });
  },
});

export const { setLicenseStatus, setTrialExpired } = licenseSlice.actions;
export default licenseSlice.reducer;
